module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "disk-group-nav"
  }, [(!_vm.expanded) ? _c('div', {
    staticClass: "disk-group-nav-bar"
  }, [_c('div', {
    staticClass: "disk-group-nav-bar-left"
  }, [_c('Icon', {
    attrs: {
      "type": "ios-compass"
    }
  }), _vm._v(" "), _c('span', [_vm._v("资料导航")])], 1), _vm._v(" "), _c('a', {
    staticClass: "disk-group-nav-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.expand.apply(null, arguments)
      }
    }
  }, [_vm._v("展开")])]) : _c('div', {
    staticClass: "disk-group-nav-panel"
  }, [_c('div', {
    staticClass: "disk-group-nav-title"
  }, [_c('strong', [_vm._v("教研群资料导航")]), _vm._v(" "), _c('a', {
    staticClass: "disk-group-nav-link",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse.apply(null, arguments)
      }
    }
  }, [_vm._v("收起")])]), _vm._v(" "), _c('div', {
    staticClass: "disk-group-nav-cats"
  }, _vm._l((_vm.categories), function(cat) {
    return _c('span', {
      key: cat.key,
      class: ['disk-group-nav-chip', {
        on: _vm.categoryKey === cat.key
      }],
      on: {
        "click": function($event) {
          return _vm.toggleCategory(cat.key)
        }
      }
    }, [_vm._v("\n        " + _vm._s(cat.title) + "\n        "), _c('a', {
      staticClass: "disk-group-nav-chip-open",
      attrs: {
        "title": "打开此分类"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return _vm.openNode(cat.targetNodeId)
        }
      }
    }, [_vm._v("打开")])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "disk-group-nav-search"
  }, [_c('Input', {
    staticStyle: {
      "width": "260px"
    },
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "搜索导航入口"
    },
    on: {
      "on-change": _vm.onKeywordChange
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }), _vm._v(" "), (_vm.hasFilter) ? _c('a', {
    staticClass: "disk-group-nav-link",
    staticStyle: {
      "margin-left": "12px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clearFilter.apply(null, arguments)
      }
    }
  }, [_vm._v("查看全部")]) : _vm._e()], 1), _vm._v(" "), (_vm.loading) ? _c('div', {
    staticClass: "disk-group-nav-empty"
  }, [_vm._v("加载导航…")]) : (_vm.loadError) ? _c('div', {
    staticClass: "disk-group-nav-empty"
  }, [_vm._v("\n      导航加载失败，请稍后重试\n      "), _c('a', {
    staticClass: "disk-group-nav-link",
    staticStyle: {
      "margin-left": "8px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.reload.apply(null, arguments)
      }
    }
  }, [_vm._v("重试")])]) : (!_vm.entries.length) ? _c('div', {
    staticClass: "disk-group-nav-empty"
  }, [_vm._v("暂无你有权访问的导航入口")]) : (!_vm.filteredEntries.length) ? _c('div', {
    staticClass: "disk-group-nav-empty"
  }, [_vm._v("没有匹配的入口，请更换关键词或查看全部")]) : _c('div', {
    staticClass: "disk-group-nav-cards"
  }, _vm._l((_vm.filteredEntries), function(item) {
    return _c('div', {
      key: item.key,
      staticClass: "disk-group-nav-card",
      on: {
        "click": function($event) {
          return _vm.openNode(item.targetNodeId)
        }
      }
    }, [_c('div', {
      staticClass: "disk-group-nav-card-title"
    }, [_vm._v(_vm._s(item.title))]), _vm._v(" "), _c('div', {
      staticClass: "disk-group-nav-card-summary"
    }, [_vm._v(_vm._s(item.summary))]), _vm._v(" "), _c('div', {
      staticClass: "disk-group-nav-card-path"
    }, [_vm._v(_vm._s(item.pathLabel || './'))]), _vm._v(" "), _c('div', {
      staticClass: "disk-group-nav-card-action"
    }, [_c('Button', {
      attrs: {
        "size": "small",
        "type": "primary",
        "loading": _vm.openingId === item.targetNodeId
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openNode(item.targetNodeId)
        }
      }
    }, [_vm._v("打开文件夹")])], 1)])
  }), 0)])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58e10340","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/disk/DiskGroupNav.vue
// module id = 1811
// module chunks = 8